import * as React from 'react';
import { connect } from 'react-redux';
import { isNaN } from 'lodash';

import BaseCampaignPage from './BaseCampaignPage';
import CampaignDeliverables from '../components/deliverables/CampaignDeliverables';

import { t } from 'utils/language';

import type { Campaign, Params } from 'types';

type StateProps = {
  campaign: Campaign | undefined | null
};

type OwnProps = {
  params: Params
};

type Props = StateProps & OwnProps;

const CampaignDeliverablesPage = ({
  params,
  campaign
}: Props) => {
  // `query` is not from State `router.query` because it is slightly delayed (in case of navigation from Messenger to filtered Content page)
  const query = window.currentLocation.query;
  const subcampaignId = query.subcampaignId ? Number(query.subcampaignId) : null;
  const initialFilter = query.filter || null;

  return (
    <BaseCampaignPage
      params={params}
      documentTitle={t('campaign_deliverables_page')}
      pageType="content"
    >
      {
        campaign && campaign.id &&
          <CampaignDeliverables
            campaignId={campaign.id}
            initialFilter={initialFilter}
            subcampaignId={!isNaN(subcampaignId) ? subcampaignId : null}
          />
      }
    </BaseCampaignPage>
  );
};

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

export default connect(mapStateToProps)(CampaignDeliverablesPage);
